export interface ILinkFormValues {
  linkName: string
  linkValue: string
}

export interface ILink {
  link_id: number
  link_name: string
  link_value: string
}

export const initLinkFormValues: ILinkFormValues = {
  linkName: '',
  linkValue: '',
}
